
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { RestaurantSubmissionForm } from "@/components/RestaurantSubmissionForm";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SignInForm } from "@/components/auth/SignInForm";
import { SignUpForm } from "@/components/auth/SignUpForm";
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm";
import { useIsMobile } from "@/hooks/use-mobile";

export const RestaurantSubmissionDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { session } = useAuth();
  const { toast } = useToast();
  const isMobile = useIsMobile();

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button 
          variant="default"
          className={`text-white ${isMobile ? 'h-8 text-sm px-3' : ''}`}
        >
          {isMobile ? 'List Venue' : 'List Your Restaurant'}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>List Your Restaurant</DialogTitle>
          <DialogDescription>
            {session
              ? "Fill out the form below to submit your restaurant for listing on our platform."
              : "Create an account or sign in to list your restaurant."}
          </DialogDescription>
        </DialogHeader>
        <ScrollArea className="h-[calc(80vh-8rem)] pr-4">
          {session ? (
            <RestaurantSubmissionForm onSuccess={() => setIsDialogOpen(false)} />
          ) : showForgotPassword ? (
            <ForgotPasswordForm
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              onBack={() => setShowForgotPassword(false)}
            />
          ) : (
            <div className="rounded-lg bg-card">
              <Tabs defaultValue="signin" className="w-full">
                <TabsList className="grid w-full grid-cols-2">
                  <TabsTrigger value="signin">Sign In</TabsTrigger>
                  <TabsTrigger value="signup">Sign Up</TabsTrigger>
                </TabsList>

                <TabsContent value="signin">
                  <SignInForm
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    onForgotPasswordClick={() => setShowForgotPassword(true)}
                  />
                </TabsContent>

                <TabsContent value="signup">
                  <SignUpForm
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                  />
                </TabsContent>
              </Tabs>
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
